import { Component, Input, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { NcdtermsheetService } from 'src/app/services/NCD/ncdtermsheet.service';
declare var $: any;
import * as _ from 'lodash';
@Component({
  selector: 'app-cashflow-calci',
  templateUrl: './cashflow-calci.component.html',
  styleUrls: ['./cashflow-calci.component.css']
})
export class CashflowCalciComponent implements OnInit {

  @Input('issueDetails') issueDetails: any;
  dtCashflowCalculations: DataTables.Settings = {};
  dtCashflowTrigger: Subject<any> = new Subject();


  cashflowCouponDetails: any = [];
  cashflowPrincipalDetails: any = [];
  totalCouponPaymentAmount: any = [];
  totalPaymentPrincipalPlusCoupon: any = [];
  selectedCashFlowType: any = [];

  cashflows: any = [];

  constructor(private ncdTermsheetService: NcdtermsheetService) { }

  ngOnInit() {
    this.dtCashflowCalculations = {
      destroy: true,
      scrollY: "400px",
      scrollCollapse: true,
      pagingType: 'full_numbers',
      paging: true,
      pageLength: 10,
      stateSave: true,
      stateDuration: -1,
      search: true,
      order: [0, 'asc'],
      lengthMenu: [[5, 10, 25, 50, 100, -1], [5, 10, 25, 50, 100, "All"]],
      // columnDefs: [{ orderable: false, targets: [] }],
      dom: 'lBfrtip',//'Bfrtip',
      buttons: [
        {
          text: '<i class="fa fa-files-o"></i> Export to Excel',
          className: 'btn btn-sm btn-warning export-btn',
          filename: 'NCD-cashflow-calculations',
          title: 'NCD-cashflow-calculations',
          extend: 'excel',
          exportOptions: {
            columns: [0, 1, 2, 3, 4],
            format: {
              body: function ( data, row, column, node ) {
                  if(data.includes("+") || data.includes("@") || data.includes("=") || data.includes("|") || data.includes("!")){
                    if(data.match(/^[a-zA-Z0-9+_.-]+@[a-zA-Z0-9.-]+[.]+[a-zA-Z0-9.-]+$/)){  return data }else{ return  "'" + data + "'"; }
                  }else{ return data }
                }
            }
          }
        }
      ]
    };

    // this.dtCashflowCalculations2 = {
    //   pagingType: 'full_numbers',
    // };

    this.cashflowCouponPaymentDateCalculation();
    //console.log("issueDetails", this.issueDetails);



  }

  cashflowCouponPaymentDateCalculation() {
    this.ncdTermsheetService.getIssueSpecificTermSheet(this.issueDetails._id).subscribe(cashflow => {
      this.cashflows = cashflow.termSheetDetails.cashflowCalculations;
      for (let i = 0; i < cashflow.termSheetDetails.cashflowCalculations.length; i++) {
        this.cashflowCouponDetails.push(cashflow.termSheetDetails.cashflowCalculations[i].coupon);
        this.cashflowPrincipalDetails.push(cashflow.termSheetDetails.cashflowCalculations[i].principalCalculation);
        this.totalCouponPaymentAmount.push(cashflow.termSheetDetails.cashflowCalculations[i].totalCouponPaymentAmount);
        this.totalPaymentPrincipalPlusCoupon.push(cashflow.termSheetDetails.cashflowCalculations[i].totalPaymentPrincipalPlusCoupon);
        this.selectedCashFlowType.push(cashflow.termSheetDetails.cashflowCalculations[i].cashFlowType);
      }

      this.dtCashflowTrigger.next();
      // this.dtCashflowTrigger2.next();
      let isCashflowHolidayPreponed = cashflow.termSheetDetails.isCashflowHolidayPreponed;
      this.getHolidayCheckForCashflowDate(isCashflowHolidayPreponed);
    })
  }

  setCashflowRelatedDatesInFormat(date) {
    if (date != null) {
      const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

      const days = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
      // ////console.log("new Date(date).getMonth() ==========", new Date(date).getMonth());
      return { day: days[new Date(date).getDay()], year: new Date(date).getFullYear(), month: months[new Date(date).getMonth()], date: new Date(date).getDate() };
    }
    return null;
  }


  getHolidayCheckForCashflowDate(isCashflowHolidayPreponed) {
    this.ncdTermsheetService.getHolidayCheckForCashflow().subscribe(holiday => {
      // console.log("holiday===================",holiday)
      var self = this;
      // COUPON DATE
      _.forEach(this.cashflowCouponDetails, function (element) {


        // var date = new Date(element.CouponPayoutDate)

        for (let count = 0; count < element.length; count++) {
          var day = new Date(element[count].CouponPayoutDate).getDay();
          for (let i = 0; i < holiday.data.length; i++) {
            if (holiday.data.indexOf(day) !== -1) {
              var date = new Date(element[count].CouponPayoutDate);
              var nextDate
              if (isCashflowHolidayPreponed == 'Yes') {
                nextDate = date.setDate(date.getDate() - 1);
              } else {
                nextDate = date.setDate(date.getDate() + 1);
              }

              let couponPayoutDate = self.setCashflowRelatedDatesInFormat(nextDate);
              element[count].CouponPayoutDate = couponPayoutDate.day + ", " + couponPayoutDate.month + " " + couponPayoutDate.date + ", " + couponPayoutDate.year
              //console.log("element.CouponPayoutDate============", element[count].CouponPayoutDate);

              // RECORD DATE
              
                // // RECORD DATE for COUPON PAYOUT DATe===============================
                // let d = new Date(nextDate);
                // var calculatedRecordDateForCoupon = d.setDate(d.getDate() - recordDate);

                // var formatedCalculatedRecordDateForCoupon;
                // if (new Date(calculatedRecordDateForCoupon).getDay() == 1) {
                //     let dt = new Date(calculatedRecordDateForCoupon);
                //     let previousDate = dt.setDate(dt.getDate() - 1);
                //     formatedCalculatedRecordDateForCoupon = new Date(previousDate).toUTCString();
                // } else {
                //     formatedCalculatedRecordDateForCoupon = new Date(calculatedRecordDateForCoupon).toUTCString();
                // }
                // =============================================================

              day = new Date(nextDate).getDay();
            } else {
              break;
            }
          }
        }
      })

      // PRINCIPAL DATE
      _.forEach(this.cashflowPrincipalDetails, function (element) {
        // for (let count = 0; count < element.length; count++) {
        var principalDay = new Date(element.PrincipalPayoutDate).getDay();
        // let principalDay = new Date(element.principalPayoutDate).getDay();
        for (let i = 0; i < holiday.data.length; i++) {
          if (holiday.data.indexOf(principalDay) !== -1) {
            let date = new Date(element.PrincipalPayoutDate)
            let nextDate = date.setDate(date.getDate() - 1);
            let couponPayoutDate = self.setCashflowRelatedDatesInFormat(nextDate);
            element.PrincipalPayoutDate = couponPayoutDate.day + ", " + couponPayoutDate.month + " " + couponPayoutDate.date + ", " + couponPayoutDate.year
            //console.log("element.PrincipalPayoutDate============", element.PrincipalPayoutDate);

            principalDay = new Date(nextDate).getDay();
          }
        }
        // }
      })
    })
  }

}
